module.exports = __webpack_public_path__ + "img/puppygallery.cdd6913b.png";